/**
 * Validation V2 Repository - GraphQL Queries
 *
 * 7 query operations for Validation primitive data access.
 */

import { gql } from '@apollo/client';
import { VALIDATION_FIELDS_FRAGMENT } from './fragments';

export const GET_VALIDATION = gql`
  ${VALIDATION_FIELDS_FRAGMENT}
  query GetValidation($tenantId: String!, $code: String!) {
    getValidation(tenantId: $tenantId, code: $code) {
      ...ValidationFields
    }
  }
`;

export const LIST_VALIDATIONS = gql`
  ${VALIDATION_FIELDS_FRAGMENT}
  query ListValidations($tenantId: String!, $limit: Int) {
    listValidations(tenantId: $tenantId, limit: $limit) {
      ...ValidationFields
    }
  }
`;

export const LIST_VALIDATIONS_BY_TYPE = gql`
  ${VALIDATION_FIELDS_FRAGMENT}
  query ListValidationsByType($tenantId: String!, $validationType: ValidationType!, $limit: Int) {
    listValidationsByType(tenantId: $tenantId, validationType: $validationType, limit: $limit) {
      ...ValidationFields
    }
  }
`;

export const LIST_VALIDATIONS_BY_FIELD = gql`
  ${VALIDATION_FIELDS_FRAGMENT}
  query ListValidationsByField($tenantId: String!, $fieldPath: String!, $limit: Int) {
    listValidationsByField(tenantId: $tenantId, fieldPath: $fieldPath, limit: $limit) {
      ...ValidationFields
    }
  }
`;

export const LIST_BLOCKING_VALIDATIONS = gql`
  ${VALIDATION_FIELDS_FRAGMENT}
  query ListBlockingValidations($tenantId: String!, $limit: Int) {
    listBlockingValidations(tenantId: $tenantId, limit: $limit) {
      ...ValidationFields
    }
  }
`;

export const LIST_ACTIVE_VALIDATIONS = gql`
  ${VALIDATION_FIELDS_FRAGMENT}
  query ListActiveValidations($tenantId: String!, $limit: Int) {
    listActiveValidations(tenantId: $tenantId, limit: $limit) {
      ...ValidationFields
    }
  }
`;

export const VALIDATE_FIELD = gql`
  query ValidateField($tenantId: String!, $fieldPath: String!, $value: JSON!, $context: JSON) {
    validateField(tenantId: $tenantId, fieldPath: $fieldPath, value: $value, context: $context) {
      valid
      errors {
        code
        message
        severity
        fieldPath
        fixSuggestion
      }
    }
  }
`;
